export default __webpack_public_path__ + "static/Send-receipts-8205841ea648afa5efa04daf899185fa.png";